import * as actionsTypes from "./actionTypes";

const fetchTerminalsOfEntity = entityId => ({
    type: actionsTypes.FETCH_TERMINALS_OF_ENTITY_REQUEST,
    entityId
});

const fetchInterfacesOfEntity = entityId => ({
    type: actionsTypes.FETCH_INTERFACES_OF_ENTITY_REQUEST,
    entityId
});

const fetchInterfacesOfTerminal = terminalId => ({
    type: actionsTypes.FETCH_INTERFACES_OF_TERMINAL_REQUEST,
    terminalId
});

const fetchUnitsOfInterfaceCategory = interfaceCategory => ({
    type:  actionsTypes.FETCH_UNITS_OF_CATEGORY_REQUEST,
    interfaceCategory
});

const loadChartData = (id, searchData) => ({
    type: actionsTypes.LOAD_CHART_WIDGET_DATA_REQUEST,
    id,
    searchData,
});

export default {
    fetchTerminalsOfEntity,
    fetchInterfacesOfEntity,
    fetchInterfacesOfTerminal,
    fetchUnitsOfInterfaceCategory,
    loadChartData
}